// Hand-written (not generated) — mirrors the shape of the generated handlers
// in this directory, same as onboarding.ts / studentFeedback.ts. Backend
// contract: himam-nest src/lms-system/resources/student-grades/* — the
// student's own grade items across all enrolled courses (studentId comes
// from the JWT; supports skip/take + assessmentType/status/courseStatus
// query filters).
export const studentGradesApiHandler = {
  getMyGrades: {
    method: 'GET',
    path: () => `student-grades`,
  },
};
